<template>
	<div class="page">



	</div>
</template>

<script>
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		data() {
			return {
				error: false,
			}
		},


		mounted() {
			this.load();
		},
		methods: {

			load() {


				this.$router.replace('/home')




			},
		}
	}
</script>

<style>

</style>